import { h } from "preact";
import { useState } from "preact/hooks";


export default function CGV() {

        return (<div style="margin: 30px;"><p align='center' style='text-align:center'><b><u><span
                style='font-size:20.0pt;font-family:"Arial"'><span
                        style='mso-spacerun:yes'> </span>CONDITIONS GENERALES BKEYS</span></u></b></p>

                <p style='text-align:justify'><b><u><span style='font-size:
20.0pt;font-family:"Arial"'></span></u></b></p>

                <p style='text-align:justify'><b><u><span style='font-size:
20.0pt;font-family:"Arial"'></span></u></b></p>

                <p style='text-align:justify'><b><span style='font-size:14.0pt;
font-family:"Arial"'>SOMMAIRE</span></b></p>



                <p style='text-align:justify'><span style='font-family:"Arial"'>Préambule</span></p>



                <p style='text-align:justify'><span style='font-family:"Arial"'>Définitions</span></p>



                <p style='text-align:justify'><span style='font-family:"Arial"'>Article
                        1 – Inscription sur le site</span></p>



                <p style='text-align:justify'><span style='font-family:"Arial"'>1.1
                        – Conditions d’inscription</span></p>

                <p style='text-align:justify'><span style='font-family:"Arial"'>1.2
                        – Ouverture d’un compte</span></p>

                <p style='text-align:justify'><span style='font-family:"Arial"'>1.3
                        – Obligation de l’Utilisateur</span></p>



                <p style='text-align:justify'><span style='font-family:"Arial"'>Article
                        2 – Politique de confidentialité et protection des données personnelles</span></p>



                <p style='text-align:justify'><span style='font-family:"Arial"'>2.1
                        – Données à caractère personnel</span></p>



                <p style='text-align:justify'><span style='font-family:"Arial"'>2.1.1
                        – Nature des données à caractère personnel de l’Utilisateur collectée</span></p>

                <p style='text-align:justify'><span style='font-family:"Arial"'>2.1.2
                        – Fondement légal du traitement</span></p>

                <p style='text-align:justify'><span style='font-family:"Arial"'>2.1.3
                        – Finalité du traitement</span></p>

                <p style='text-align:justify'><span style='font-family:"Arial"'>2.1.4
                        – Destinataire des données à caractère personnel de l’Utilisateur</span></p>

                <p style='text-align:justify'><span style='font-family:"Arial"'>2.1.5
                        – Durée des données à caractère personnel de l’Utilisateur</span></p>



                <p style='text-align:justify'><span style='font-family:"Arial"'>2.2
                        – Droit d’opposition d’accès, de rectification et de suppression de
                        l’Utilisateur</span></p>



                <p style='text-align:justify'><span style='font-family:"Arial"'>2.2.1
                        – Droits de l’Utilisateur</span></p>

                <p style='text-align:justify'><span style='font-family:"Arial"'>2.2.2
                        – Modalités d’exercice de ses droits par l’Utilisateur</span></p>



                <p style='text-align:justify'><span style='font-family:"Arial"'>2.3
                        – Sécurité et archivage des données à caractère personnel de l’Utilisateur</span></p>



                <p style='text-align:justify'><span style='font-family:"Arial"'>2.4
                        – Règlement des différends concernant le traitement des données</span></p>



                <p style='text-align:justify'><span style='font-family:"Arial"'>2.5
                        – Newsletter et alertes</span></p>



                <p style='text-align:justify'><span style='font-family:"Arial"'>2.6
                        – Cookies</span></p>



                <p style='text-align:justify'><span style='font-family:"Arial"'>Article
                        3 – Ambassadeur </span></p>



                <p style='text-align:justify'><span style='font-family:"Arial"'>3.1
                        – Obligations générales </span></p>

                <p style='text-align:justify'><span style='font-family:"Arial"'>3.2
                        – Obligations particulières</span></p>

                <p style='text-align:justify'><span style='font-family:"Arial"'>3.3
                        – Obligation de déclarer ses revenus</span></p>

                <p style='text-align:justify'><span style='font-family:"Arial"'>Article
                        4 – Vendeur </span></p>



                <p style='text-align:justify'><span style='font-family:"Arial"'>4.1
                        – Obligations générales du Vendeur</span></p>

                <p style='text-align:justify'><span style='font-family:"Arial"'>4.2
                        – Dossier de diagnostic Technique</span></p>

                <p style='text-align:justify'><span style='font-family:"Arial"'>4.3
                        – Vente d’un lot de copropriété – Mesurage et documents à fournir</span></p>

                <p style='text-align:justify'><span style='font-family:"Arial"'>4.4
                        – Détermination du prix de vente</span></p>

                <p style='text-align:justify'><span style='font-family:"Arial"'>4.5
                        – Droit de rétractation</span></p>

                <p style='text-align:justify'><span style='font-family:"Arial"'>4.6
                        – Honoraires Bkeys</span></p>



                <p style='text-align:justify'><span style='font-family:"Arial"'>Article
                        5 – Acquéreur</span></p>



                <p style='text-align:justify'><span style='font-family:"Arial"'>Article
                        6 – Responsabilités</span></p>



                <p style='text-align:justify'><span style='font-family:"Arial"'>6.1
                        – Limitation de responsabilité</span></p>

                <p style='text-align:justify'><span style='font-family:"Arial"'>6.2
                        – Accès au Site</span></p>

                <p style='text-align:justify'><span style='font-family:"Arial"'>6.3
                        – suspension temporaire des obligations des parties</span></p>



                <p style='text-align:justify'><span style='font-family:"Arial"'>Article
                        7 – Propriété intellectuelle</span></p>



                <p style='text-align:justify'><span style='font-family:"Arial"'>Article
                        8 – Dispositions diverses</span></p>





                <p style='text-align:justify'><b><u><span style='font-size:
16.0pt;font-family:"Arial"'>MENTIONS LEGALES</span></u></b></p>



                <p style='text-align:justify'><span style='font-family:"Arial"'>Dernière
                        modification&nbsp;: 20/12/2020</span></p>



                <p style='text-align:justify'><span style='font-family:"Arial"'>Le
                        site </span><a href="http://www.bkeys.com"><span style='font-family:"Arial";
color:windowtext'>www.bkeys.com</span></a><span ><span
                                style='font-family:"Arial";color:windowtext;text-decoration:
none;text-underline:none'>, ses filiales</span></span><span style='font-family:
"Futura Medium",sans-serif'> et les applications smartphones Bkeys sont la propriété
                                de&nbsp;Bkeys Limited – Global Business Company au capital de 1 000 $ sise Premier
                                Business Center, 14 Poudriere Street, Port Louis, ILE MAURICE.</span></p>





                <p style='text-align:justify'><span style='font-family:"Arial"'>Hébergeur&nbsp;:
                        Amazon Web Services</span></p>





                <p style='text-align:justify'><b><u><span style='font-size:
16.0pt;font-family:"Arial"'>CONDITIONS GENERALES DU SITE</span></u></b></p>

                <p style='text-align:justify'><b><u><span style='font-size:
16.0pt;font-family:"Arial"'></span></u></b></p>

                <p style='text-align:justify'><b><span style='font-size:14.0pt;
font-family:"Arial"'>Préambule</span></b></p>



                <p style='text-align:justify'><span style='font-family:"Arial"'>La
                        société Bkeys édite une plateforme digitale et un portail d’annonces dans
                        le domaine de l’immobilier, accessible sur un site internet, notamment à
                        l’adresse </span><a href="http://www.bkeys.com"><span style='font-family:"Arial"'>www.bkeys.com</span></a>
                        <span style='font-family:"Arial"'>(ci-après
                                «&nbsp;Bkeys&nbsp;»), et sous forme d’une application mobile et tablette.</span></p>



                <p style='text-align:justify'><span style='font-family:"Arial"'>La
                        plateforme est destinée&nbsp;:</span></p>



                <p style='text-align:justify;text-indent:-18.0pt;
mso-list:l9 level1 lfo1'><span style='font-family:Symbol;
mso-fareast-font-family:Symbol;mso-bidi-font-family:Symbol'><span
                                        style='mso-list:Ignore'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        </span></span></span><span style='font-family:"Arial"'>À
                                                permettre à des personnes physiques ou morales, pour leur propre compte, en
                                                toute autonomie, et sous leur propre responsabilité, d’indiquer à Bkeys&nbsp;: </span></p>

                <p style='margin-left:72.0pt;mso-add-space:
auto;text-align:justify;text-indent:-18.0pt;mso-list:l9 level2 lfo1'><span
                                style='font-family:"Courier New";mso-fareast-font-family:"Courier New"'><span
                                        style='mso-list:Ignore'>o<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;
                                        </span></span></span><span style='font-family:"Arial"'>Un
                                                ou des propriétaire(s) immobilier(s) désirant vendre leur(s) bien(s).</span></p>

                <p style='margin-left:72.0pt;mso-add-space:
auto;text-align:justify;text-indent:-18.0pt;mso-list:l9 level2 lfo1'><span
                                style='font-family:"Courier New";mso-fareast-font-family:"Courier New"'><span
                                        style='mso-list:Ignore'>o<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;
                                        </span></span></span><span style='font-family:"Arial"'>Un
                                                ou des acquéreur(s) désirant acquérir un ou des bien(s) immobilier(s)</span></p>

                <p style='text-align:justify'><span
                        style='font-family:"Arial"'><span
                                style='mso-spacerun:yes'> </span></span></p>

                <p style='text-align:justify;text-indent:-18.0pt;
mso-list:l9 level1 lfo1'><span style='font-family:Symbol;
mso-fareast-font-family:Symbol;mso-bidi-font-family:Symbol'><span
                                        style='mso-list:Ignore'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        </span></span></span><span style='font-family:"Arial"'>À
                                                offrir la possibilité à tout propriétaire immobilier de conclure un mandat de
                                                vente sans exclusivité avec Bkeys afin que cette dernière puisse commercialiser
                                                son bien en qualité d’agent immobilier.</span></p>



                <p style='text-align:justify'><span style='font-family:"Arial"'>Le
                        portail d’annonces est destiné&nbsp;:</span></p>



                <p style='text-align:justify;text-indent:-18.0pt;
mso-list:l3 level1 lfo2'><span style='font-family:Symbol;
mso-fareast-font-family:Symbol;mso-bidi-font-family:Symbol'><span
                                        style='mso-list:Ignore'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        </span></span></span><span style='font-family:"Arial"'>À
                                                la mise en ligne de publicité immobilière afin de commercialiser le bien des
                                                propriétaires ayant contracté un mandat de vente avec Bkeys.</span></p>

                <p style='text-align:justify'><span
                        style='font-family:"Arial"'></span></p>

                <p style='text-align:justify;text-indent:-18.0pt;
mso-list:l3 level1 lfo2'><span style='font-family:Symbol;
mso-fareast-font-family:Symbol;mso-bidi-font-family:Symbol'><span
                                        style='mso-list:Ignore'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        </span></span></span><span style='font-family:"Arial"'>À
                                                identifier des acquéreurs et les mettre en relation avec les propriétaires afin
                                                d’aboutir à la conclusion de la vente.</span></p>



                <p style='text-align:justify'><span style='font-family:"Arial"'>Le
                        Site et/ou L’Application est ensuite exploité par la filiale locale de Bkeys du
                        pays où se situe le bien.</span></p>



                <p style='text-align:justify'><span style='font-family:"Arial"'>Le
                        Site et/ou l’Application agit ensuite comme un intermédiaire immobilier entre Vendeur
                        et Acquéreur en mettant tout en œuvre dans le but de provoquer l’entente des
                        parties&nbsp;; ceci moyennant le paiement d’une commission représentant une
                        fraction du prix de vente.</span></p>



                <p style='text-align:justify'><span style='font-family:"Arial"'>Le
                        règlement des honoraires afférents à la prestation ne sera exigible qu’au jour
                        de la signature de l’acte authentique de vente notariée validant définitivement
                        le transfert de propriété.</span></p>



                <p style='text-align:justify'><span style='font-family:"Arial"'>Les
                        présentes Conditions Générales d’Utilisation (ci-après CGU) ont pour objet d’encadrer
                        l’accès et les modalités d’utilisation du Site et/ou de l’Application pour les
                        utilisateurs. Nous vous invitons à en prendre connaissance.</span></p>







                <p style='text-align:justify'><b><span style='font-size:14.0pt;
font-family:"Arial"'>Définitions</span></b></p>

                <p style='text-align:justify'><span style='font-size:14.0pt;
font-family:"Arial"'></span></p>

                <p style='text-align:justify'><i><span style='font-family:"Arial"'>Application&nbsp;</span></i><span
                        style='font-family:"Arial"'>: <span style='color:black;
mso-themecolor:text1;background:white'>désigne le service électronique
                                interactif exploité par Bkeys, accessible depuis tout terminal disposant d'une
                                connexion au réseau Internet, par téléchargement gratuit sur l'AppStore ou
                                GooglePlay ou par consultation via un navigateur web et qui permet, le cas
                                échéant après installation, d'accéder aux Services.</span></span></p>



                <p style='text-align:justify'><i><span style='font-family:"Arial"'>Ambassadeur</span></i><span
                        style='font-family:"Arial"'>&nbsp;: désigne tout Utilisateur
                        qui indique et renseigne, en toute autonomie, des propriétaires immobiliers
                        souhaitant vendre leur bien ou des prospects souhaitant acquérir un bien
                        immobilier par l’intermédiaire de Bkeys. </span></p>



                <p style='text-align:justify'><i><span style='font-family:"Arial"'>Acquéreur</span></i><span
                        style='font-family:"Arial"'>&nbsp;: désigne tout Utilisateur
                        qui souhaite devenir propriétaire d’un bien immobilier.</span></p>



                <p style='text-align:justify'><i><span style='font-family:"Arial"'>Bkeys</span></i><span
                        style='font-family:"Arial"'>&nbsp;: désigne la société telle
                        qu’elle est définie à la fois dans les mentions légales et en préambule des
                        présentes CGU.</span></p>



                <p style='text-align:justify'><i><span style='font-family:"Arial"'>CGU</span></i><span
                        style='font-family:"Arial"'>&nbsp;: désigne les présentes Conditions
                        Générales d’Utilisation.</span></p>

                <p style='text-align:justify'><i><span style='font-family:"Arial"'>Data
                        room</span></i><span style='font-family:"Arial"'>&nbsp;:
                                désigne un espace de travail professionnel sécurisé́ et confidentiel (réseau sécurisé́,
                                accès par login/mot de passe personnel, hébergement auprès d'un professionnel)
                                mis par Bkeys à la disposition des utilisateurs et intervenants au dossier
                                (diagnostiqueurs immobiliers dûment mandaté et notaires partis à l’acte de
                                vente), destinée à la préparation des actes constitutifs du dossier de vente
                                et à l'information des différentes parties et des intervenants.</span></p>

                <p style='text-align:justify'><i><span style='font-family:"Arial"'>Données</span></i><span
                        style='font-family:"Arial"'>&nbsp;: <span style='color:black;
mso-themecolor:text1;background:white'>désignent les données à caractère
                                personnel telles que définies à l'article 4 du Règlement (UE) 2016/679 du
                                Parlement européen et du Conseil du 27 avril 2016 relatif à la protection des
                                personnes physiques à l'égard du traitement des données à caractère personnel
                                et à la libre circulation de ces données (ci-après désigné&nbsp;</span><span
                                        style='color:black;mso-themecolor:text1'>Règlement Général sur la Protection
                                des Données, «&nbsp;RGPD<span style='background:white'>&nbsp;») qui sont
                                        fournies par l'Utilisateur à Bkeys ou qui sont recueillies par Bkeys à
                                        l'occasion de l'utilisation du Site et/ou de l'Application.</span></span></span></p>



                <p style='text-align:justify'><i><span style='font-family:"Arial"'>Espace
                        Utilisateur&nbsp;: </span></i><span style='font-family:"Arial"'>désigne
                                les différentes pages du site accessibles aux Utilisateurs qui créent un espace
                                personnel via un identifiant et un mot de passe.</span></p>



                <p style='text-align:justify'><i><span style='font-family:"Arial"'>Services</span></i><span
                        style='font-family:"Arial"'>&nbsp;: <span style='color:black;
mso-themecolor:text1;background:white'>désignent les services fournis par Bkeys
                                sur le Site Internet et/ou l'Application et décrits en préambule des présentes
                                CGU, ainsi que leurs extensions sous forme d'alerte, de newsletters, d'agenda
                                et de fonctionnalités du terminal de l'Utilisateur, nécessaires à leur
                                fonctionnement.</span></span></p>

                <p style='text-align:justify'><span style='font-family:"Arial";
color:black;mso-themecolor:text1;background:white'></span></p>

                <p style='text-align:justify'><span style='font-family:"Arial";
color:black;mso-themecolor:text1;background:white'>RGPD&nbsp;: Règlement
                        Général sur la Protection des Données</span><span style='font-family:"Arial";
color:black;mso-themecolor:text1'></span></p>



                <p style='text-align:justify;background:white'><i><span
                        style='font-family:"Arial";color:black;mso-color-alt:windowtext'>Site</span></i><span
                                style='font-family:"Arial";color:black;mso-color-alt:windowtext'>&nbsp;:
                                site Internet accessible à l’URL suivante http://www.bkeys.com ainsi qu’à
                                travers les applications mobiles Bkeys iOS et Android, gérés par Bkeys.</span><span
                                        style='font-family:"Arial"'></span></p>



                <p style='text-align:justify'><i><span style='font-family:"Arial"'>Utilisateur</span></i><span
                        style='font-family:"Arial"'>&nbsp;: désigne tout visiteur qui
                        souhaite bénéficier des services proposés par Bkeys en créant un espace
                        personnel, pour son propre compte ou en tant que représentant légal d’une
                        personne morale. </span></p>



                <p style='text-align:justify'><i><span style='font-family:"Arial"'>Vendeur</span></i><span
                        style='font-family:"Arial"'>&nbsp;: désigne tout Utilisateur
                        propriétaire qui souhaite vendre un bien immobilier lui appartenant.</span></p>

                <p style='text-align:justify;background:white'><i><span style='font-family:
"Futura Medium",sans-serif;color:black;mso-color-alt:windowtext'>Visiteur</span></i><span
                                style='font-family:"Arial";color:black;mso-color-alt:windowtext'>&nbsp;:
                                désigne tout internaute non inscrit naviguant sur le Site et qui </span><span
                                        style='font-family:"Arial",sans-serif;color:black;mso-color-alt:windowtext'>​</span><span
                                                style='font-family:"Arial";color:black;mso-color-alt:windowtext'>déclare
                                en accédant et utilisant le Site avoir pris connaissance des présentes CGU et
                                les accepter expressément sans réserve et/ou modification de quelque nature que
                                ce soit</span><span style='font-family:"Arial",sans-serif;color:black;
mso-color-alt:windowtext'>​</span><span style='font-family:"Arial";
color:black;mso-color-alt:windowtext'>. </span></p>



                <p style='text-align:justify'><b><span style='font-family:"Arial"'>Article
                        1 – Inscription au Site</span></b></p>



                <p style='text-align:justify'><b><span style='font-family:"Arial"'>1.1
                        Conditions d’inscription</span></b></p>

                <p style='margin-left:21.0pt;mso-add-space:auto;
text-align:justify'><span style='font-family:"Arial"'></span></p>

                <p style='text-align:justify'><span style='font-family:"Arial"'>L’utilisation
                        du Site et/ou de l’Application est réservée aux personnes physiques âgées de
                        plus de 18 ans non frappées d’incapacité juridique et aux représentants légaux
                        de personnes morales ne faisant pas l’objet d’une procédure de sauvegarde, de
                        redressement judiciaire ou de liquidation judiciaire.</span></p>



                <p style='text-align:justify'><span style='font-family:"Arial"'>Toute
                        personne accédant, utilisant ou s’inscrivant sur le Site et/ou l’Application déclare
                        et garantit remplir les conditions sus-évoquées.</span></p>



                <p style='text-align:justify'><b><span style='font-family:"Arial"'>1.2
                        Ouverture d’un compte</span></b></p>



                <p style='text-align:justify'><span style='font-family:"Arial"'>Pour
                        s’inscrire sur le Site et/ou l’Application, l’Utilisateur devra créer un Compte
                        Utilisateur à l’aide de son adresse mail et de son numéro de téléphone
                        portable.</span></p>



                <p style='text-align:justify'><span style='font-family:"Arial"'>L’Utilisateur
                        remplira les champs du formulaire d’inscription et fournira des informations
                        complètes et exactes. </span></p>



                <p style='text-align:justify'><span style='font-family:"Arial"'>Parmi
                        les champs obligatoires, l’Utilisateur devra indiquer sa civilité, son prénom,
                        son nom, son adresse postale, son adresse mail, son numéro de téléphone
                        portable et son mot de passe. Dans le cas d’une utilisation du Site et/ou de
                        l’Application par le représentant légal d’une personne morale, l’Utilisateur
                        devra indiquer son nom, son prénom, une adresse mail et un numéro de téléphone
                        portable, sa fonction dans la société, la forme juridique, le nom, le numéro de
                        SIREN, le numéro de TVA intracommunautaire le cas échéant et l’adresse postale
                        de la personne morale.</span></p>



                <p style='text-align:justify'><b><span style='font-family:"Arial"'>1.3
                        Obligation de l’Utilisateur</span></b></p>

                <p style='text-align:justify'><b><span style='font-family:"Arial"'></span></b></p>

                <p style='margin-bottom:12.0pt;text-align:justify;line-height:
17.15pt'><span style='font-family:"Arial"'>Pour procéder à
                                l’inscription, l’Utilisateur doit remplir tous les champs obligatoires ; à
                                défaut l’inscription ne pourra être validée.</span></p>

                <p style='margin-bottom:12.0pt;text-align:justify;line-height:
17.15pt'><span style='font-family:"Arial"'>Les Utilisateurs
                                garantissent et déclarent sur l'honneur que toutes les informations renseignées
                                sur le Site et/ou l’Application, notamment lors de leur inscription, sont
                                exactes et conformes à la réalité. Ils s’engagent à mettre à jour leurs
                                informations personnelles à partir de la page, dédiée à ces dernières,
                                disponible sur leur Compte Utilisateur.</span></p>

                <p style='margin-bottom:12.0pt;text-align:justify;line-height:
17.15pt'><span style='font-family:"Arial"'>Tout Utilisateur
                                enregistré dispose d’un identifiant et d’un mot de passe. Ces derniers sont
                                strictement personnels et confidentiels et ne devront en aucun cas faire
                                l’objet d’une communication à des tiers sous peine de suppression du compte de
                                l’Utilisateur enregistré contrevenant. Chaque Utilisateur inscrit est
                                personnellement responsable du maintien de la confidentialité de son
                                identifiant et de son mot de passe. Bkeys ne sera en aucun cas tenue pour
                                responsable de l’usurpation d’identité d’un Utilisateur. Si un Utilisateur
                                suspecte une fraude à n’importe quel moment, il devra contacter Bkeys dans les
                                plus brefs délais afin que cette dernière puisse prendre les mesures
                                nécessaires et régulariser la situation.</span></p>

                <p style='text-align:justify'><span style='font-family:"Arial"'>Chaque
                        Utilisateur, qu’il soit une personne physique ou morale, ne peut être titulaire
                        que d’un seul compte sur le Site et/ou l’Application.<b></b></span></p>





                <p style='text-align:justify'><b><span style='font-family:"Arial"'>Article
                        2 – Politique de confidentialité et protection des données personnelles </span></b></p>

                <p style='text-align:justify'><b><span style='font-family:"Arial"'></span></b></p>

                <p style='text-align:justify'><b><span style='font-family:"Arial"'>2.1
                        – Données à caractère personnel</span></b></p>

                <p style='text-align:justify'><b><span style='font-family:"Arial"'></span></b></p>

                <p style='text-align:justify'><b><span style='font-family:"Arial"'>2.1.1
                        – Nature des données à caractère personnel de l’Utilisateur collectée</span></b></p>

                <p style='text-align:justify'><b><span style='font-family:"Arial"'></span></b></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial";
mso-fareast-font-family:Calibri;mso-fareast-theme-font:minor-latin;color:#393939;
mso-fareast-language:EN-US'>Parmi les Données que Bkeys collecte auprès de
                                l'Utilisateur ou de son terminal peuvent figurer :</span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial";
mso-fareast-font-family:Calibri;mso-fareast-theme-font:minor-latin;color:#393939;
mso-fareast-language:EN-US'></span></p>

                <p style='text-align:justify;text-indent:-18.0pt;
mso-list:l5 level1 lfo9;tab-stops:11.0pt 36.0pt;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:Symbol;
mso-fareast-font-family:Symbol;mso-bidi-font-family:Symbol;color:#1D1D1D'><span
                                        style='mso-list:Ignore'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        </span></span></span><span style='font-family:"Arial";
color:#1D1D1D'>Son nom et prénom.</span></p>

                <p style='text-align:justify;text-indent:-18.0pt;
mso-list:l5 level1 lfo9;tab-stops:11.0pt 36.0pt;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:Symbol;
mso-fareast-font-family:Symbol;mso-bidi-font-family:Symbol;color:#1D1D1D'><span
                                        style='mso-list:Ignore'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        </span></span></span><span style='font-family:"Arial";
color:#1D1D1D'>Son adresse postale.</span></p>

                <p style='text-align:justify;text-indent:-18.0pt;
mso-list:l5 level1 lfo9;tab-stops:11.0pt 36.0pt;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:Symbol;
mso-fareast-font-family:Symbol;mso-bidi-font-family:Symbol;color:#1D1D1D'><span
                                        style='mso-list:Ignore'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        </span></span></span><span style='font-family:"Arial";
color:#1D1D1D'>Son adresse de courrier électronique (email).</span></p>

                <p style='text-align:justify;text-indent:-18.0pt;
mso-list:l5 level1 lfo9;tab-stops:11.0pt 36.0pt;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:Symbol;
mso-fareast-font-family:Symbol;mso-bidi-font-family:Symbol;color:#1D1D1D'><span
                                        style='mso-list:Ignore'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        </span></span></span><span style='font-family:"Arial";
color:#1D1D1D'>Son numéro de téléphone.</span></p>

                <p style='text-align:justify;text-indent:-18.0pt;
mso-list:l5 level1 lfo9;tab-stops:11.0pt 36.0pt;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:Symbol;
mso-fareast-font-family:Symbol;mso-bidi-font-family:Symbol;color:#1D1D1D'><span
                                        style='mso-list:Ignore'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        </span></span></span><span style='font-family:"Arial";
color:#1D1D1D'>Son lieu et son année de naissance.</span></p>

                <p style='text-align:justify;text-indent:-18.0pt;
mso-list:l5 level1 lfo9;tab-stops:11.0pt 36.0pt;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:Symbol;
mso-fareast-font-family:Symbol;mso-bidi-font-family:Symbol;color:#1D1D1D'><span
                                        style='mso-list:Ignore'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        </span></span></span><span style='font-family:"Arial";
color:#1D1D1D'>L'adresse IP de son terminal et/ou le numéro SDK (Software
                                Development Kit) de l'Application qu'il utilise.</span></p>

                <p style='text-align:justify;text-indent:-18.0pt;
mso-list:l5 level1 lfo9;tab-stops:11.0pt 36.0pt;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:Symbol;
mso-fareast-font-family:Symbol;mso-bidi-font-family:Symbol;color:#1D1D1D'><span
                                        style='mso-list:Ignore'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        </span></span></span><span style='font-family:"Arial";
color:#1D1D1D'>Son identifiant unique et son mot de passe,</span></p>

                <p style='text-align:justify;text-indent:-18.0pt;
mso-list:l5 level1 lfo9;tab-stops:11.0pt 36.0pt;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:Symbol;
mso-fareast-font-family:Symbol;mso-bidi-font-family:Symbol;color:#1D1D1D'><span
                                        style='mso-list:Ignore'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        </span></span></span><span style='font-family:"Arial";
color:#1D1D1D'>Des informations relatives à sa navigation et à ses interactions
                                avec les Services, le Site et/ou l'Application (historique de recherches,
                                formulaires, cookies, etc.),</span></p>

                <p style='text-align:justify;text-indent:-18.0pt;
mso-list:l5 level1 lfo9;tab-stops:11.0pt 36.0pt;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:Symbol;
mso-fareast-font-family:Symbol;mso-bidi-font-family:Symbol;color:#1D1D1D'><span
                                        style='mso-list:Ignore'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        </span></span></span><span style='font-family:"Arial";
color:#1D1D1D'>Les informations relatives à son profil dans un réseau social si
                                celui-ci est public et uniquement si l'Utilisateur décide de lier son compte à
                                un réseau social et de partager ses actions dans les conditions précisées à
                                l'article CONNEXION VIA LES RESEAUX SOCIAUX des présentes CGU.</span></p>

                <p style='text-align:justify;tab-stops:11.0pt 36.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial";
mso-fareast-font-family:Calibri;mso-fareast-theme-font:minor-latin;color:#1D1D1D;
mso-fareast-language:EN-US'></span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial";
mso-fareast-font-family:Calibri;mso-fareast-theme-font:minor-latin;color:#393939;
mso-fareast-language:EN-US'>La Société collecte les informations fournies par
                                les Utilisateurs notamment :</span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial";
mso-fareast-font-family:Calibri;mso-fareast-theme-font:minor-latin;color:#393939;
mso-fareast-language:EN-US'></span></p>

                <p style='text-align:justify;text-indent:-18.0pt;
mso-list:l8 level1 lfo10;tab-stops:11.0pt 36.0pt;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:Symbol;
mso-fareast-font-family:Symbol;mso-bidi-font-family:Symbol;color:#1D1D1D'><span
                                        style='mso-list:Ignore'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        </span></span></span><span style='font-family:"Arial";
color:#1D1D1D'>Lors de la création de leurs Espaces Utilisateurs.</span></p>

                <p style='text-align:justify;text-indent:-18.0pt;
mso-list:l8 level1 lfo10;tab-stops:11.0pt 36.0pt;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:Symbol;
mso-fareast-font-family:Symbol;mso-bidi-font-family:Symbol;color:#1D1D1D'><span
                                        style='mso-list:Ignore'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        </span></span></span><span style='font-family:"Arial";
color:#1D1D1D'>Lors de la saisie et de l'envoi des formulaires de prise de
                                rendez-vous de visite,</span></p>

                <p style='text-align:justify;text-indent:-18.0pt;
mso-list:l8 level1 lfo10;tab-stops:11.0pt 36.0pt;mso-layout-grid-align:none;
text-autospace:none'><span style='font-size:14.0pt;
font-family:Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:Symbol;
color:#1D1D1D'><span style='mso-list:Ignore'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </span></span></span><span style='font-family:"Arial";
color:#1D1D1D'>Lors de leurs navigations sur le Site Internet et/ou
                                l'Application (consultation d'annonces, recherches, etc.).</span><span
                                        style='font-size:14.0pt;font-family:"Arial";color:#1D1D1D'></span></p>

                <p style='text-align:justify;tab-stops:11.0pt 36.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-size:14.0pt;
font-family:"Arial";mso-fareast-font-family:Calibri;
mso-fareast-theme-font:minor-latin;color:#1D1D1D'></span></p>

                <p style='text-align:justify;tab-stops:11.0pt 36.0pt;
mso-layout-grid-align:none;text-autospace:none'><b><span style='font-family:
"Futura Medium",sans-serif'>2.1.2 – Fondement légal du traitement</span></b></p>

                <p style='text-align:justify;tab-stops:11.0pt 36.0pt;
mso-layout-grid-align:none;text-autospace:none'><b><span style='font-family:
"Futura Medium",sans-serif'></span></b></p>

                <p style='text-align:justify'><span style='font-family:"Arial";
color:black;mso-themecolor:text1;background:white'>Dans le cadre de
                        l'acceptation des CGU, et en application de l'article 6.1 du RGPD,
                        l'Utilisateur est informé que les différents traitements de ses Données évoqués
                        ci-après sont nécessaires&nbsp;:</span></p>

                <p style='text-align:justify'><span style='font-family:"Arial";
color:black;mso-themecolor:text1;background:white'></span></p>

                <p style='text-align:justify;text-indent:-18.0pt;
mso-list:l7 level1 lfo11'><span style='font-family:Symbol;
mso-fareast-font-family:Symbol;mso-bidi-font-family:Symbol;color:black;
mso-themecolor:text1'><span style='mso-list:Ignore'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </span></span></span><span style='font-family:"Arial";
color:black;mso-themecolor:text1;background:white'>A l'exécution et à la
                                réalisation des Services proposés par la Société et dont la fourniture est
                                régie par les présentes CGU constituant le contrat souscrit par l'Utilisateur
                                visant à l'accompagner dans le cadre de son projet immobilier.</span><span
                                        style='font-family:"Arial";color:black;mso-themecolor:text1'></span></p>

                <p style='text-align:justify;text-indent:-18.0pt;
mso-list:l7 level1 lfo11'><span style='font-family:Symbol;
mso-fareast-font-family:Symbol;mso-bidi-font-family:Symbol;color:black;
mso-themecolor:text1'><span style='mso-list:Ignore'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </span></span></span><span style='font-family:"Arial";
color:black;mso-themecolor:text1;background:white'>Aux intérêts légitimes
                                poursuivis par Bkeys d'amélioration de son Service et de compréhension des
                                attentes des Utilisateurs, permettant notamment la protection des droits et des
                                Données de l'Utilisateur.</span><span style='font-family:"Arial";
color:black;mso-themecolor:text1'></span></p>

                <p style='text-align:justify'><span style='font-family:"Arial";
color:black;mso-themecolor:text1'></span></p>

                <p style='text-align:justify'><b><span style='font-family:"Arial"'>2.1.3
                        – Finalité du traitement </span></b></p>

                <p style='text-align:justify'><span style='font-family:"Arial";
color:black;mso-themecolor:text1'></span></p>

                <p style='margin:0cm;text-align:justify'><span style='font-family:"Arial";
color:black;mso-themecolor:text1'>Les Données des Utilisateurs traitées par Bkeys
                        sont utilisées pour les finalités suivantes :</span></p>

                <p style='margin:0cm;text-align:justify'><span style='font-family:"Arial";
color:black;mso-themecolor:text1'></span></p>

                <p style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;
text-align:justify;text-indent:-18.0pt;mso-list:l13 level1 lfo12'><span
                                style='font-family:Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:
Symbol;color:black;mso-themecolor:text1'><span style='mso-list:Ignore'>·<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></span><span
                                                style='font-family:"Arial";color:black;mso-themecolor:text1'>Pour
                                leur permettre de créer un Compte Utilisateur.</span></p>

                <p style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;
text-align:justify;text-indent:-18.0pt;mso-list:l13 level1 lfo12'><span
                                style='font-family:Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:
Symbol;color:black;mso-themecolor:text1'><span style='mso-list:Ignore'>·<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></span><span
                                                style='font-family:"Arial";color:black;mso-themecolor:text1'>Pour
                                leur fournir les Services disponibles à travers le Site Internet et/ou
                                l'Application.</span></p>

                <p style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;
text-align:justify;text-indent:-18.0pt;mso-list:l13 level1 lfo12'><span
                                style='font-family:Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:
Symbol;color:black;mso-themecolor:text1'><span style='mso-list:Ignore'>·<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></span><span
                                                style='font-family:"Arial";color:black;mso-themecolor:text1'>Pour
                                répondre à leurs demandes.</span></p>

                <p style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;
text-align:justify;text-indent:-18.0pt;mso-list:l13 level1 lfo12'><span
                                style='font-family:Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:
Symbol;color:black;mso-themecolor:text1'><span style='mso-list:Ignore'>·<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></span><span
                                                style='font-family:"Arial";color:black;mso-themecolor:text1'>Pour
                                établir des statistiques générales sur le trafic du Site et/ou de l’Application
                                et des différentes rubriques qu'il contient.</span></p>

                <p style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;
text-align:justify;text-indent:-18.0pt;mso-list:l13 level1 lfo12'><span
                                style='font-family:Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:
Symbol;color:black;mso-themecolor:text1'><span style='mso-list:Ignore'>·<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></span><span
                                                style='font-family:"Arial";color:black;mso-themecolor:text1'>Pour
                                leur envoyer par courrier électronique les réponses, informations diverses ou
                                annonces publiées sur le Site Internet et/ou sur l'Application par Bkeys ou par
                                ses partenaires immobiliers.</span></p>

                <p style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;
text-align:justify;text-indent:-18.0pt;mso-list:l13 level1 lfo12'><span
                                style='font-family:Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:
Symbol;color:black;mso-themecolor:text1'><span style='mso-list:Ignore'>·<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></span><span
                                                style='font-family:"Arial";color:black;mso-themecolor:text1'>Pour
                                leur envoyer par courrier électronique des infolettres (« newsletter ») sur
                                l'évolution du Site et/ou de l'Application et des différentes rubriques du Site
                                et/ou de l'Application.</span></p>

                <p style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;
text-align:justify;text-indent:-18.0pt;mso-list:l13 level1 lfo12'><span
                                style='font-family:Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:
Symbol;color:black;mso-themecolor:text1'><span style='mso-list:Ignore'>·<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></span><span
                                                style='font-family:"Arial";color:black;mso-themecolor:text1'>Pour
                                mieux connaître leurs besoins et simplifier leurs navigations et/ou pour
                                analyser ou prédire des éléments les concernant comme leurs préférences
                                personnelles, intérêts, fiabilité, et leurs comportements.</span></p>

                <p style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;
text-align:justify;text-indent:-18.0pt;mso-list:l13 level1 lfo12'><span
                                style='font-family:Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:
Symbol;color:black;mso-themecolor:text1'><span style='mso-list:Ignore'>·<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></span><span
                                                style='font-family:"Arial";color:black;mso-themecolor:text1'>Pour
                                mener des enquêtes et études de satisfaction.</span></p>

                <p style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;
text-align:justify'><span style='font-family:"Arial";
color:black;mso-themecolor:text1'></span></p>

                <p style='margin:0cm;text-align:justify'><span style='font-family:"Arial";
color:black;mso-themecolor:text1'>Les Données des Utilisateurs traitées par Bkeys
                        sont également utilisées à des fins marketing pour répondre aux demandes de
                        renseignements et de prospections émises par les Utilisateurs à des tiers
                        partenaires, sous réserve de l'accord exprès des Utilisateurs.</span></p>

                <p style='margin:0cm;text-align:justify'><span style='font-family:"Arial";
color:black;mso-themecolor:text1'></span></p>

                <p style='margin:0cm;text-align:justify'><span style='font-family:"Arial";
color:black;mso-themecolor:text1'></span></p>

                <p style='margin:0cm;text-align:justify'><span style='font-family:"Arial";
color:black;mso-themecolor:text1'></span></p>

                <p style='text-align:justify'><b><span style='font-family:"Arial"'>2.1.4
                        – Destinataire des données à caractère personnel de l’Utilisateur</span></b></p>

                <p style='text-align:justify'><b><span style='font-family:"Arial"'></span></b></p>

                <p style='margin:0cm;text-align:justify'><span style='font-family:"Arial";
color:black;mso-themecolor:text1'>Les données des Utilisateurs sont destinées à
                        Bkeys notamment afin de faire bénéficier les Utilisateurs de services
                        personnalisés ainsi qu'aux autres sociétés filiales du groupe Bkeys à des fins
                        d'étude et de connaissance client. L'Utilisateur accepte par conséquent le
                        partage de ses données entre les sociétés du groupe Bkeys. </span></p>

                <p style='margin:0cm;text-align:justify'><span style='font-family:"Arial";
color:black;mso-themecolor:text1'></span></p>

                <p style='margin:0cm;text-align:justify'><span style='font-family:"Arial";
color:black;mso-themecolor:text1'>Pour connaître la liste à jour des entités du
                        groupe Bkeys susceptibles d'être destinataires de vos données, vous pouvez en
                        faire la demande à Bkeys.</span></p>

                <p style='margin:0cm;text-align:justify'><span style='font-family:"Arial";
color:black;mso-themecolor:text1'><br />
                        Par ailleurs, les Données peuvent être communiquées, dans le respect des lois
                        applicables à Bkeys, pour une ou plusieurs des finalités décrites à l'Article 2.3,
                        aux personnes listées ci-dessous :</span></p>

                <ul >
                        <li style='color:black;mso-themecolor:text1;mso-margin-top-alt:
     auto;mso-margin-bottom-alt:auto;text-align:justify;mso-list:l10 level1 lfo13;
     tab-stops:list 36.0pt'><span style='font-family:"Arial"'>Au
                                        personnel habilité et autorisé des sociétés du groupe Bkeys pouvant être
                                        amené à traiter les Données.</span></li>
                        <li style='color:black;mso-themecolor:text1;mso-margin-top-alt:
     auto;mso-margin-bottom-alt:auto;text-align:justify;mso-list:l10 level1 lfo13;
     tab-stops:list 36.0pt'><span style='font-family:"Arial"'>Aux
                                        Partenaires immobiliers de Bkeys que les Utilisateurs souhaitent
                                        expressément et spécifiquement contacter afin de s’assurer l’un de leurs
                                        services ou l’une de leurs prestations (diagnostics immobiliers, photographies
                                        professionnelles…).</span></li>
                        <li style='color:black;mso-themecolor:text1;mso-margin-top-alt:
     auto;mso-margin-bottom-alt:auto;text-align:justify;mso-list:l10 level1 lfo13;
     tab-stops:list 36.0pt'><span style='font-family:"Arial"'>Aux
                                        prestataires informatiques de Bkeys chargés notamment de fournir un
                                        service et des publicités adaptés aux Utilisateurs et de mesurer la
                                        fréquentation du Site Internet et/ou de l'Application conformément aux
                                        dispositions de l'article « Utilisation des technologies de suivi (Site
                                        internet et/ou Application) » des présentes.</span></li>
                        <li style='color:black;mso-themecolor:text1;mso-margin-top-alt:
     auto;mso-margin-bottom-alt:auto;text-align:justify;mso-list:l10 level1 lfo13;
     tab-stops:list 36.0pt'><span style='font-family:"Arial"'>Aux
                                        autorités administratives ou judiciaires,</span></li>
                        <li style='color:black;mso-themecolor:text1;mso-margin-top-alt:
     auto;mso-margin-bottom-alt:auto;text-align:justify;mso-list:l10 level1 lfo13;
     tab-stops:list 36.0pt'><span style='font-family:"Arial"'>Aux
                                        partenaires commerciaux de Bkeys lorsque les Utilisateurs ont accepté
                                        expressément de recevoir les offres promotionnelles de leur part.</span></li>
                </ul>

                <p style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify'><b><span style='font-family:"Arial"'>2.1.5
                                – Durée des données à caractère personnel de l’Utilisateur<span
                                        style='color:black;mso-themecolor:text1'></span></span></b></p>

                <p style='text-align:justify'><span style='font-family:"Arial";
color:black;mso-themecolor:text1;background:white'>Dans le cadre de la
                        recherche d'achat et/ou de vente d'un bien immobilier et des services associés,
                        les Données sont conservées par Bkeys, dans le respect des lois applicables à Bkeys,
                        sans limite de temps durant toute la durée d’activité et d’existence de Bkeys à
                        compter de la dernière activité de l'Utilisateur sur le Site et/ou
                        l’Application (modification de son compte, navigation, saisie d'un formulaire...)</span></p>

                <p style='margin:0cm;text-align:justify'><span style='font-size:10.5pt;
font-family:"Source Sans Pro",sans-serif;color:#494949'></span></p>

                <p style='text-align:justify'><b><span style='font-family:"Arial"'>2.2
                        – Droit d’opposition d’accès, de rectification et de suppression de
                        l’Utilisateur<span style='color:black;mso-themecolor:text1'></span></span></b></p>

                <p style='text-align:justify'><span style='font-family:"Arial";
color:black;mso-themecolor:text1'></span></p>

                <p style='text-align:justify'><b><span style='font-family:"Arial"'>2.2.1
                        – Droits de l’Utilisateur<span style='color:black;mso-themecolor:text1'></span></span></b></p>

                <p style='text-align:justify'><span style='font-family:"Arial";
color:black;mso-themecolor:text1'></span></p>

                <p style='margin:0cm;text-align:justify'><span style='font-family:"Arial";
color:black;mso-themecolor:text1'>Conformément aux lois applicables,
                        l'Utilisateur a la faculté :</span></p>

                <ul >
                        <li style='color:black;mso-themecolor:text1;mso-margin-top-alt:
     auto;mso-margin-bottom-alt:auto;text-align:justify;mso-list:l14 level1 lfo14;
     tab-stops:list 36.0pt'><span style='font-family:"Arial"'>De
                                        s'opposer, à tout moment pour des raisons tenant à sa situation
                                        personnelle, au traitement de ses Données dans le cadre des Services
                                        fournis par Bkeys.</span></li>
                        <li style='color:black;mso-themecolor:text1;mso-margin-top-alt:
     auto;mso-margin-bottom-alt:auto;text-align:justify;mso-list:l14 level1 lfo14;
     tab-stops:list 36.0pt'><span style='font-family:"Arial"'>De
                                        s'opposer, à tout moment au traitement des Données à des fins de
                                        prospection.</span></li>
                        <li style='color:black;mso-themecolor:text1;mso-margin-top-alt:
     auto;mso-margin-bottom-alt:auto;text-align:justify;mso-list:l14 level1 lfo14;
     tab-stops:list 36.0pt'><span style='font-family:"Arial"'>De
                                        s'opposer à la communication des Données à des tiers, d'accéder à
                                        l'ensemble de ses Données traitées dans le cadre des Services fournis par Bkeys.</span></li>
                        <li style='color:black;mso-themecolor:text1;mso-margin-top-alt:
     auto;mso-margin-bottom-alt:auto;text-align:justify;mso-list:l14 level1 lfo14;
     tab-stops:list 36.0pt'><span style='font-family:"Arial"'>De
                                        rectifier, mettre à jour et supprimer ses Données traitées dans le cadre
                                        des Services fournis par Bkeys,</span></li>
                        <li style='color:black;mso-themecolor:text1;mso-margin-top-alt:
     auto;mso-margin-bottom-alt:auto;text-align:justify;mso-list:l14 level1 lfo14;
     tab-stops:list 36.0pt'><span style='font-family:"Arial"'>Sous
                                        réserve de justifier de leur identité auprès de Bkeys et lorsque cela est
                                        techniquement possible, de demander la portabilité des seules données à
                                        caractère personnel qu'il a fournies à Bkeys. Ne sont notamment pas
                                        comprises dans les données fournies à Bkeys, les analyses sur ces données
                                        effectuées par Bkeys.</span></li>
                        <li style='color:black;mso-themecolor:text1;mso-margin-top-alt:
     auto;mso-margin-bottom-alt:auto;text-align:justify;mso-list:l14 level1 lfo14;
     tab-stops:list 36.0pt'><span style='font-family:"Arial"'>De
                                        fournir à Bkeys des directives relatives au sort de ses Données après sa
                                        mort.</span></li>
                </ul>

                <p style='margin:0cm;text-align:justify'><span style='font-family:"Arial";
color:black;mso-themecolor:text1'>En cas d'exercice du droit d'opposition par
                        l'Utilisateur, Bkeys cessera le traitement de ses Données, sauf en cas de
                        motif(s) légitime(s) et impérieux pour le traitement, ou pour assurer la
                        constatation, l'exercice ou la défense de ses droits en justice, conformément
                        au RGPD. Le cas échéant, Bkeys informera l'Utilisateur des motifs pour lesquels
                        les droits qu'il exerce ne sauraient être satisfaits en tout ou partie.</span></p>

                <p style='text-align:justify;tab-stops:11.0pt 36.0pt;
mso-layout-grid-align:none;text-autospace:none'><b><span style='font-size:14.0pt;
font-family:"Arial";mso-fareast-font-family:Calibri;
mso-fareast-theme-font:minor-latin;color:#1D1D1D'></span></b></p>

                <p style='text-align:justify;tab-stops:11.0pt 36.0pt;
mso-layout-grid-align:none;text-autospace:none'><b><span style='font-family:
"Futura Medium",sans-serif'>2.2.2 – Modalités d’exercice de ses droits par
                                l’Utilisateur</span></b></p>

                <p style='text-align:justify;tab-stops:11.0pt 36.0pt;
mso-layout-grid-align:none;text-autospace:none'><b><span style='font-family:
"Futura Medium",sans-serif'></span></b></p>

                <p style='text-align:justify'><span style='font-family:"Arial";
color:black;mso-themecolor:text1;background:white'>Pour exercer ses droits, il
                        suffit à l'Utilisateur d'adresser un simple courrier à Bkeys aux coordonnées
                        visées dans les mentions légales des CGU ou de contacter Bkeys via la rubrique
                        « Nous contacter » en prenant soin de joindre un justificatif d'identité à sa
                        demande (mentionner ses noms, prénoms, adresse de courrier électronique) -
                        conformément au Chapitre III du RGPD.</span><span style='font-family:"Arial";
color:black;mso-themecolor:text1'></span></p>

                <p style='text-align:justify;tab-stops:11.0pt 36.0pt;
mso-layout-grid-align:none;text-autospace:none'><b><span style='font-size:14.0pt;
font-family:"Arial";mso-fareast-font-family:Calibri;
mso-fareast-theme-font:minor-latin;color:#1D1D1D'></span></b></p>

                <p style='text-align:justify'><b><span style='font-family:"Arial"'>2.3
                        – Sécurité et archivage des données à caractère personnel de l’Utilisateur</span></b></p>

                <p style='text-align:justify'><b><span style='font-family:"Arial"'></span></b></p>

                <p style='text-align:justify'><span style='font-family:"Arial";
color:black;mso-themecolor:text1;background:white'>Bkeys collecte et traite les
                        Données avec la plus grande confidentialité et sécurité, et dans le respect des
                        lois applicables.</span></p>

                <p style='text-align:justify'><span style='font-family:"Arial";
color:black;mso-themecolor:text1'><br />
                        <span style='background:white'>Bkeys s'engage à prendre toutes mesures
                                raisonnables nécessaires à la sécurisation et à la protection des Données des
                                Utilisateurs du Site et/ou de l'Application et des Services, collectées et
                                traités par ses soins.</span></span></p>

                <p style='text-align:justify'><span style='font-family:"Arial";
color:black;mso-themecolor:text1;background:white'></span></p>

                <p style='text-align:justify'><b><span style='font-family:"Arial"'>2.4
                        – Règlement des différends concernant le traitement des données</span></b></p>

                <p style='text-align:justify'><b><span style='font-family:"Arial"'></span></b></p>

                <p style='text-align:justify'><span style='font-family:"Arial";
color:black;mso-themecolor:text1;background:white'>En cas de différend entre Bkeys
                        et l'Utilisateur concernant le traitement des Données, l'Utilisateur pourra
                        adresser sa réclamation à Bkeys en la contactant aux coordonnées figurant dans
                        les mentions légales des CGU. Bkeys s'efforcera de trouver une solution
                        satisfaisante pour l'Utilisateur, pour assurer le respect de la réglementation
                        applicable.</span><span style='font-family:"Arial";
color:black;mso-themecolor:text1'><br />
                                <span style='background:white'>En l'absence de réponse de Bkeys ou si le
                                        différend persiste malgré la proposition de Bkeys, l'Utilisateur a la
                                        possibilité, conformément aux dispositions du RGPD d'introduire une réclamation
                                        auprès de l'autorité de contrôle compétente de l'État Membre de l'Union
                                        Européenne au sein duquel l'Utilisateur réside habituellement.</span></span></p>

                <p style='text-align:justify'><span style='font-family:"Arial";
color:black;mso-themecolor:text1;background:white'></span></p>

                <p style='text-align:justify'><b><span style='font-family:"Arial"'>2.5
                        – Newsletter et alertes</span></b></p>

                <p style='text-align:justify'><span style='font-family:"Arial";
color:black;mso-themecolor:text1'></span></p>

                <p style='text-align:justify'><span style='font-family:"Arial";
color:black;mso-themecolor:text1;background:white'>Afin de tenir informé
                        l'Utilisateur de l'actualité de Bkeys et des avantages dont il pourrait
                        bénéficier, celui-ci peut recevoir des informations commerciales de Bkeys par
                        communication électronique (email, sms…). Si l'Utilisateur ne souhaite pas
                        recevoir d'offres et informations de Bkeys, il peut s'opposer aux envois en le
                        précisant, à tout moment, dans son compte rubrique 'Abonnements' et en cliquant
                        sur le lien hypertexte de désabonnement qui se trouve en bas de chaque
                        communication électronique reçue.</span><span style='font-family:"Arial";
color:black;mso-themecolor:text1'><br />
                                <span style='background:white'>L'Utilisateur peut personnaliser l'envoi des
                                        newsletters et gérer les abonnements aux alertes qu'il souhaite recevoir lors
                                        de la création de son compte ou en se rendant dans son compte rubrique
                                        'Abonnements'. L'Utilisateur a alors la possibilité de sélectionner parmi les
                                        différentes catégories de newsletters et alertes celles qui l'intéressent. </span></span></p>

                <p style='text-align:justify'><span style='font-family:"Arial";
color:black;mso-themecolor:text1;background:white'></span></p>

                <p style='text-align:justify'><span style='font-family:"Arial";
color:black;mso-themecolor:text1;background:white'>L'Utilisateur peut faire
                        cesser à tout moment l'envoi des newsletters et alertes en se rendant dans son
                        compte.</span></p>

                <p style='text-align:justify'><span style='font-family:"Arial";
color:black;mso-themecolor:text1;background:white'></span></p>

                <p style='text-align:justify'><span style='font-family:"Arial";
color:black;mso-themecolor:text1;background:white'>A défaut de sélection et si
                        celui-ci ne s'est pas opposé lors de la création de son compte, l'Utilisateur
                        sera susceptible de recevoir des informations sur l'actualité Bkeys et des
                        newsletters et alertes qui portent sur des biens et services analogues à ceux
                        que l'Utilisateur a déjà consultés sur le Site et/ou l'Application.</span></p>

                <p style='text-align:justify'><span style='font-family:"Arial";
color:black;mso-themecolor:text1;background:white'></span></p>

                <p style='text-align:justify'><b><span style='font-family:"Arial"'>2.6
                        – Cookies<span style='color:black;mso-themecolor:text1;background:white'></span></span></b></p>

                <p style='text-align:justify'><span style='font-family:"Arial";
color:black;mso-themecolor:text1'></span></p>

                <p style='text-align:justify'><span style='font-family:"Arial";
color:black;mso-themecolor:text1;background:white'>Bkeys utilise des cookies
                        sur son Site et/ou son Application. Des cookies sont des informations
                        afférentes à la navigation de l'ordinateur de l'Utilisateur du Site et/ou de
                        l'Application et qui permettent de déterminer les pages qu'il a consultées,
                        leur date et heure de consultation.</span></p>

                <p style='text-align:justify'><span style='font-family:"Arial";
color:black;mso-themecolor:text1'><br />
                        <span style='background:white'>A aucun moment, ces cookies ne permettent à Bkeys
                                d'identifier personnellement l'Utilisateur. La durée de conservation de ces
                                cookies dans l'ordinateur de l'Utilisateur n'excède pas treize (13) mois.
                                L'Utilisateur est informé qu'il a la faculté de s'opposer à l'enregistrement de
                                ces cookies et ce notamment en configurant son navigateur Internet pour ce
                                faire, dont le détail est prévu dans l’annexe des présentes CGU.</span></span></p>

                <p style='text-align:justify'><span style='font-family:"Arial";
color:black;mso-themecolor:text1'></span></p>

                <p style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify'><b><span style='font-family:"Arial"'>Article
                                3 – Ambassadeur </span></b></p>

                <p style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify'><b><span style='font-family:"Arial"'>3.1
                                Obligations générales </span></b></p>

                <p style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify'><span style='font-family:"Arial"'>L’inscription
                                sur le Site et/ou l’Application par l’Ambassadeur est non exclusive et
                                totalement libre. Ce dernier peut y mettre fin sans préavis et sans motif à
                                n’importe quel moment.</span></p>

                <p style='text-align:justify'><span style='font-family:"Arial";
color:black;mso-color-alt:windowtext;background:white'>L’Ambassadeur doit
                        refuser d’apporter une affaire à Bkeys et/ou arrêter toute participation dans
                        toute activité qui pourrait présenter un conflit d’intérêts ou pourrait
                        contrevenir à une loi applicable, à ces CGU ou à ses engagements envers un
                        tiers.</span><span style='font-family:"Arial";background:
white'></span></p>

                <p style='text-align:justify'><span style='font-family:"Arial";
background:white'></span></p>

                <p style='margin-bottom:7.5pt;text-align:justify'><span
                        style='font-family:"Arial"'>L’Ambassadeur doit s’assurer,
                        préalablement à l’indication d’une affaire, que son statut juridique lui permet
                        de réaliser cette prestation et de recevoir une rémunération (uniquement en cas
                        de conclusion de la vente par Bkeys) conformément aux lois en vigueur dans son
                        pays. <span style='color:black;mso-color-alt:windowtext;background:white'>A cet
                                égard, Bkeys invite, notamment, tout Ambassadeur salarié à s’assurer que son
                                contrat de travail, ainsi que tout autre document régissant son activité
                                professionnelle (conventions, règlements, etc.), ne contiennent aucune
                                stipulation susceptible de l’empêcher de procéder à l’apport d’affaire ou, à
                                défaut, qu’il a obtenu toute autorisation préalable nécessaire de la part de
                                son ou de ses employeurs.</span></span></p>

                <p style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify'><b><span style='font-family:"Arial"'>3.2
                                Obligations particulières&nbsp;</span></b></p>

                <p style='margin-bottom:7.5pt;text-align:justify'><span
                        style='font-family:"Arial"'>L’Ambassadeur remplira son apport
                        d’affaire en totale indépendance de Bkeys, dont il reconnaît ne pas être
                        salarié, ni sous-traitant, ni mandataire. </span></p>

                <p style='margin-bottom:7.5pt;text-align:justify'><span
                        style='font-family:"Arial"'>L’Ambassadeur s’engage à
                        garantir Bkeys contre tout recours résultant de son apport d’affaire. La
                        responsabilité de Bkeys ne peut ainsi être engagée de quelque manière que ce
                        soit, à l’égard de l’Ambassadeur, du Vendeur, de l’Acquéreur ou de toute autre
                        personne, du fait de l’accomplissement, par un Ambassadeur, d’un apport
                        d’affaire.</span></p>

                <p style='margin-bottom:7.5pt;text-align:justify'><span
                        style='font-family:"Arial"'>L’Ambassadeur est seul
                        responsable du préjudice direct ou indirect qu’il est susceptible de subir du
                        fait d’informations inexactes, incomplètes, et/ ou trompeuses qu’il fournirait
                        lors de la création de son Compte Utilisateur ou&nbsp;en l’absence de mise à
                        jour de ces informations, ce dont il assume seul les conséquences.</span></p>

                <p style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify'><b><span style='font-family:"Arial"'>3.3
                                Obligation de déclarer ses revenus</span></b></p>

                <p style='text-align:justify'><span style='font-family:"Arial";
color:black;mso-color-alt:windowtext;background:white'>L’Ambassadeur déclare
                        avoir rempli toutes les obligations déclaratives imposées par les lois et
                        règlements de son pays sans que la Société ne puisse être mise&nbsp;en cause en
                        cas de défaut.</span><span style='font-family:"Arial"'></span></p>

                <p style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify'><span style='font-family:"Arial"'>Bkeys
                                rappelle aux Agents Personnels qu’ils ont l’obligation de déclarer les
                                commissions qui leur sont versées, aux administrations fiscales et sociales.</span></p>



                <p style='text-align:justify'><b><span style='font-family:"Arial"'>Article
                        4 – Vendeur et biens mis en vente</span></b></p>

                <p style='text-align:justify'><b><span style='font-family:"Arial"'></span></b></p>

                <p style='text-align:justify'><b><span style='font-family:"Arial"'>4.1
                        Obligation générales du Vendeur</span></b></p>

                <p style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify'><span style='font-family:"Arial"'>Bkeys
                                attire l’attention du Vendeur sur son obligation générale d’information
                                concernant tout élément dont il a connaissance et qui peut impacter le
                                consentement de l’Acquéreur. Le Vendeur doit, le cas échéant, faire procéder
                                sans délai à diverses vérifications et faire appel aux experts
                                compétents.&nbsp;</span></p>

                <p style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify'><span style='font-family:"Arial"'>L’ensemble
                                de ces vérifications et intervention d’experts compétent est de la
                                responsabilité et à la charge du Vendeur et ne rentre pas dans les missions de Bkeys
                                au titre du présent contrat. En attendant les vérifications, le Vendeur atteste
                                sur l’honneur que, à sa connaissance, l’état du bien permet sa vente dans le
                                respect des lois et des règlements en vigueur.</span></p>

                <p style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify'><span style='font-family:"Arial"'>Le Vendeur
                                s’oblige à informer Bkeys de la signature effective et définitive de l’acte de
                                vente.</span></p>

                <p style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify'><b><span style='font-family:"Arial"'>4.2</span></b><span
                                style='font-family:"Arial"'> <b>Détermination du prix de
                                        vente</b></span></p>

                <p style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify'><span style='font-family:"Arial"'>Le
                                Vendeur détermine le prix de vente de son bien immobilier librement sous sa
                                seule responsabilité. </span></p>

                <p style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify'><span style='font-family:"Arial"'>Bkeys
                                se réserve le droit et la possibilité de suggérer une modification de prix au Vendeur
                                au cours de la vie du contrat.</span></p>

                <p style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify'><b><span style='font-family:"Arial"'>4.2
                                Droit de rétractation</span></b></p>

                <p style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify'><span style='font-family:"Arial"'>Bkeys
                                informe le Vendeur qu’il dispose du droit de se rétracter du mandat de vente
                                sans donner de motif à n’importe quel moment grâce à la fonction prévue à cet
                                effet dans son compte client.</span></p>

                <p style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify'><b><span style='font-family:"Arial"'>4.3
                                Honoraires Bkeys</span></b></p>

                <p style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify'><span style='font-family:"Arial"'>Les
                                honoraires de la présente prestation de service sont de&nbsp;: </span></p>

                <p style='mso-margin-top-alt:auto;mso-margin-bottom-alt:
auto;mso-add-space:auto;text-align:justify;text-indent:-18.0pt;mso-list:l11 level1 lfo15'><span
                                style='font-family:Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:
Symbol'><span style='mso-list:Ignore'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </span></span></span><span style='font-family:"Arial"'>X%
                                        (X pour cent) toutes taxes comprises du prix de vente définitif, pour toutes
                                        transactions immobilières inférieures à 240 000 € (deux cent quarante mille
                                        euros). </span></p>

                <p style='mso-margin-top-alt:auto;mso-margin-bottom-alt:
auto;mso-add-space:auto;text-align:justify;text-indent:-18.0pt;mso-list:l11 level1 lfo15'><span
                                style='font-family:Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:
Symbol'><span style='mso-list:Ignore'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </span></span></span><span style='font-family:"Arial"'>4
                                        800 € (quatre mille huit cents euros) forfaitaires toutes taxes comprises pour
                                        toutes transactions immobilières supérieures à 240 000 € (deux cent quarante
                                        mille euros).</span></p>

                <p style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify'><span style='font-family:"Arial"'>Ces
                                honoraires sont à la charge exclusive du Vendeur.</span></p>

                <p style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify'><span style='font-family:"Arial"'>Le
                                versement des honoraires sera exigible le jour de la signature de l’acte
                                authentique de vente constatant le transfert de propriété, par l’intermédiaire
                                de la comptabilité du notaire rédacteur de l’acte.</span></p>

                <p style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify'><span style='font-family:"Arial"'></span></p>

                <p style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify'><b><span style='font-family:"Arial"'>Article
                                5 – Acquéreur</span></b></p>

                <p style='mso-margin-bottom-alt:auto;text-align:justify'><span
                        style='font-family:"Arial"'>Le service est 100 % gratuit
                        pour les Acquéreurs.&nbsp;</span></p>

                <p style='mso-margin-bottom-alt:auto;text-align:justify'><span
                        style='font-family:"Arial"'>Les Acquéreurs ont accès aux fonctionnalités
                        suivante depuis le Site et/ou l’Application :</span></p>

                <ul >
                        <li style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
     text-align:justify;mso-list:l4 level1 lfo8;tab-stops:list 36.0pt'><span
                                        style='font-family:"Arial"'>La recherche d’annonce.</span></li>
                        <li style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
     text-align:justify;mso-list:l4 level1 lfo8;tab-stops:list 36.0pt'><span
                                        style='font-family:"Arial"'>La consultation d’annonce.</span></li>
                        <li style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
     text-align:justify;mso-list:l4 level1 lfo8;tab-stops:list 36.0pt'><span
                                        style='font-family:"Arial"'>La création d’un Compte Utilisateur.</span></li>
                        <li style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
     text-align:justify;mso-list:l4 level1 lfo8;tab-stops:list 36.0pt'><span
                                        style='font-family:"Arial"'>Prise de RDV pour une
                                        visite d’un bien qui sera effectuée soit par le vendeur soit par l’Ambassadeur
                                        pour le compte et sous la responsabilité du Vendeur.</span></li>
                        <li style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
     text-align:justify;mso-list:l4 level1 lfo8;tab-stops:list 36.0pt'><span
                                        style='font-family:"Arial"'>Faire une offre d’achat.</span></li>
                        <li style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
     text-align:justify;mso-list:l4 level1 lfo8;tab-stops:list 36.0pt'><span
                                        style='font-family:"Arial"'>Accéder à la Data Room
                                        contenant toutes les informations et documentation concernant le bien
                                        qu’il souhaite acquérir.</span></li>
                </ul>

                <p style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify'><span style='font-family:"Arial"'>L’Acquéreur
                                s’oblige à prévenir Bkeys de toute visite préalable organisée et qu’il ne
                                serait pas en mesure d’honorer.&nbsp; </span></p>

                <p style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify'><span style='font-family:"Arial"'>L’acquéreur
                                s’oblige à informer Bkeys de la signature effective et définitive de l’acte authentique
                                de vente.</span></p>

                <p style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify'><b><span style='font-family:"Arial"'>Article
                                6 - Responsabilités</span></b></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><b><span style='font-family:"Arial"'>6.1
                                - Limitation de responsabilité</span></b></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'></span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'>Bkeys
                                ne peut être tenue responsable ni du contenu des annonces, ni des actions (ou
                                absence d'action) des Utilisateurs.</span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'></span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'>Bkeys
                                ne peut être tenue responsable de l'utilisation frauduleuse par un tiers et des
                                conséquences éventuelles de l'identifiant et/ou du mot de passe de
                                l'Utilisateur.</span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'></span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'>Des
                                liens hypertextes sur le Site et/ou sur l’Application pouvant renvoyer à
                                d'autres sites, Bkeys n'est pas responsable de leur contenu ou de leurs
                                agissements.</span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'></span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'>Bkeys
                                ne peut assurer que le Vendeur ou l'Acquéreur concluront la transaction.</span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'>Le
                                contrat créé lors de l'acceptation de l'offre d'achat de l'Acquéreur par le
                                Vendeur lie uniquement le Vendeur et l'Acquéreur. Bkeys, jouant seulement un
                                rôle d'intermédiaire, ne saurait être tenu responsable des litiges et de leur
                                issue. </span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'></span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><b><span style='font-family:"Arial"'>6.2
                                - Accès au Site</span></b></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'></span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'>Bkeys
                                ne peut garantir que le Site et/ou l’Application sera accessible en permanence
                                et n'est tenu qu'à une obligation de moyens concernant la continuité de son
                                accès.</span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'></span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'>Bkeys
                                se réserve le droit de suspendre l'accès au Site et/ou l’Application,
                                temporairement ou définitivement, pour toutes raisons, et notamment en cas de
                                maintenance ou en cas d'urgence sans préavis ni indemnité et sans engager sa
                                responsabilité.</span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'>En
                                conséquence, Bkeys ne peut être tenue responsable de la perte d'argent, de réputation,
                                de dommages spéciaux, indirects ou induits résultant directement ou indirectement
                                de l'utilisation du Site et/ou l’Application.</span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'></span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><b><span style='font-family:"Arial"'>6.3
                                - Suspension temporaire des obligations des parties</span></b></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'></span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'>Les
                                obligations des parties au présent contrat sont suspendues, en cas de :</span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'></span></p>

                <p style='text-align:justify;text-indent:-18.0pt;
mso-list:l0 level1 lfo6;mso-layout-grid-align:none;text-autospace:none'><span
                                style='font-family:Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:
Symbol'><span style='mso-list:Ignore'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </span></span></span><span style='font-family:"Arial"'>Force
                                        majeure </span></p>

                <p style='text-align:justify;text-indent:-18.0pt;
mso-list:l0 level1 lfo6;mso-layout-grid-align:none;text-autospace:none'><span
                                style='font-family:Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:
Symbol'><span style='mso-list:Ignore'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </span></span></span><span style='font-family:"Arial"'>Grève
                        </span></p>

                <p style='text-align:justify;text-indent:-18.0pt;
mso-list:l0 level1 lfo6;mso-layout-grid-align:none;text-autospace:none'><span
                                style='font-family:Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:
Symbol'><span style='mso-list:Ignore'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </span></span></span><span style='font-family:"Arial"'>Panne
                        </span></p>

                <p style='text-align:justify;text-indent:-18.0pt;
mso-list:l0 level1 lfo6;mso-layout-grid-align:none;text-autospace:none'><span
                                style='font-family:Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:
Symbol'><span style='mso-list:Ignore'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </span></span></span><span style='font-family:"Arial"'>Blocage
                                        ou de difficulté concernant le matériel informatique, les logiciels informatiques,
                                        ou le réseau Internet utilisés par Bkeys</span></p>

                <p style='text-align:justify;text-indent:-18.0pt;
mso-list:l0 level1 lfo6;mso-layout-grid-align:none;text-autospace:none'><span
                                style='font-family:Symbol;mso-fareast-font-family:Symbol;mso-bidi-font-family:
Symbol'><span style='mso-list:Ignore'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </span></span></span><span style='font-family:"Arial"'>Suspension
                                        de l'accès au Site et/ou l’Application.</span></p>

                <p style='text-align:justify;mso-layout-grid-align:
none;text-autospace:none'><span style='font-family:"Arial"'></span></p>

                <p style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify'><b><span style='font-family:"Arial"'>Article
                                7 – Propriété intellectuelle</span></b></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'>Tous
                                les droits de propriété intellectuelle (tels que notamment droits d’auteur,
                                droits voisins, droits des marques, droits des producteurs de bases de données)
                                portant tant sur la structure que sur les contenus du Site et/ou l’Application,
                                et notamment les éléments suivants : les images, sons, vidéos, photographies,
                                logos, marques, éléments graphiques, textuels, visuels, outils, logiciels,
                                documents, données, etc. sont réservés.</span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'></span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'>Ces
                                éléments sont la propriété de Bkeys, ils sont mis à disposition des Utilisateurs,
                                à titre gracieux, pour la seule utilisation du Site et/ou l’Application, et
                                dans le cadre d’une utilisation normale de ses fonctionnalités. Les
                                Utilisateurs s’engagent à ne les modifier en aucune manière.</span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'></span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'>Toute
                                utilisation non expressément autorisée de ces éléments entraîne une violation
                                des droits d’auteur et constitue une contrefaçon. Elle peut aussi entraîner une
                                violation des droits à l’image, droits des personnes ou de tous autres droits
                                et réglementations en vigueur. Elle peut donc engager la responsabilité civile
                                et/ou pénale de son auteur.</span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'></span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'>Il
                                est interdit à tout Utilisateur ou Visiteur de copier, modifier, créer une œuvre
                                dérivée, inverser la conception ou l’assemblage ou de toute autre manière
                                tenter de trouver le code source, vendre, attribuer, sous licencier ou
                                transférer de quelque manière que ce soit tout droit afférant aux éléments
                                précédemment cités.</span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'></span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'>Tous
                                Utilisateurs et Visiteurs s’engagent notamment à ne pas&nbsp;:</span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'></span></p>

                <p style='margin-left:53.4pt;mso-add-space:
auto;text-align:justify;text-indent:-18.0pt;mso-list:l6 level1 lfo7;mso-layout-grid-align:
none;text-autospace:none'><span style='font-family:Symbol;
mso-fareast-font-family:Symbol;mso-bidi-font-family:Symbol'><span
                                        style='mso-list:Ignore'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        </span></span></span><span style='font-family:"Arial"'>Extraire,
                                                à des fins commerciales ou non, tout ou partie des informations présentes sur
                                                le Site et/ou l’Application.</span></p>

                <p style='margin-left:53.4pt;mso-add-space:
auto;text-align:justify;text-indent:-18.0pt;mso-list:l6 level1 lfo7;mso-layout-grid-align:
none;text-autospace:none'><span style='font-family:Symbol;
mso-fareast-font-family:Symbol;mso-bidi-font-family:Symbol'><span
                                        style='mso-list:Ignore'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        </span></span></span><span style='font-family:"Arial"'>Reproduire
                                                sur tout autre support, à des fins commerciales ou non, tout ou partie des informations
                                                présentes sur le Site et/ou l’Application.</span></p>

                <p style='margin-left:53.4pt;mso-add-space:
auto;text-align:justify;text-indent:-18.0pt;mso-list:l6 level1 lfo7;mso-layout-grid-align:
none;text-autospace:none'><span style='font-family:Symbol;
mso-fareast-font-family:Symbol;mso-bidi-font-family:Symbol'><span
                                        style='mso-list:Ignore'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        </span></span></span><span style='font-family:"Arial"'>Utiliser
                                                un robot, notamment d'exploration (spider), une application de recherche ou récupération
                                                de sites Internet ou tout autre moyen permettant de récupérer ou d'indexer tout
                                                ou partie du contenu du Site et/ou de l’Application excepté en cas
                                                d'autorisation expresse et préalable de Bkeys.</span></p>

                <p style='margin-left:53.4pt;mso-add-space:
auto;text-align:justify;text-indent:-18.0pt;mso-list:l6 level1 lfo7;mso-layout-grid-align:
none;text-autospace:none'><span style='font-family:Symbol;
mso-fareast-font-family:Symbol;mso-bidi-font-family:Symbol'><span
                                        style='mso-list:Ignore'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        </span></span></span><span style='font-family:"Arial"'>Copier
                                                les informations sur des supports de toute nature permettant de reconstituer tout
                                                ou partie des fichiers d'origine.</span></p>

                <p style='margin-left:53.4pt;mso-add-space:auto;
text-align:justify;mso-layout-grid-align:none;text-autospace:none'><span
                                style='font-family:"Arial"'></span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'>Toute
                                reproduction, représentation, publication, transmission, utilisation, modification
                                ou extraction de tout ou partie des éléments précédemment cités et ce de
                                quelque manière que ce soit, faite sans l'autorisation préalable et écrite de
                                Bkeys est illicite. Ces actes illicites engagent la responsabilité de leurs
                                auteurs et sont susceptibles d'entraîner des poursuites judiciaires à leur
                                encontre et notamment pour contrefaçon.</span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'></span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'>Les
                                marques et logos Bkeys, Bkeys.com, Bkeys.fr sont des marques déposées. Toute
                                reproduction totale ou partielle de ces marques et/ou logos sans l’autorisation
                                préalable et écrite de Bkeys est interdite.</span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'></span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'>Bkeys
                                est producteur des bases de données du Site et de l’Application. En
                                conséquence, toute extraction et/ou réutilisation de la ou des bases de
                                données.</span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'></span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'>Bkeys
                                peut contenir des liens hypertextes redirigeant vers des sites exploités par
                                des tiers. Ces liens sont fournis à simple titre d'information. La décision
                                d'activer ces liens relève de la pleine et entière responsabilité de
                                l'Utilisateur.</span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'></span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'>Bkeys
                                n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à l'accès,
                                au contenu ou à l'utilisation de ces sites, ainsi qu'aux dommages pouvant
                                résulter de la consultation des informations présentes sur ces sites.</span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'></span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'>Aucun
                                lien hypertexte ne peut être créé vers le Site et/ou l’Application sans
                                l’accord préalable et exprès de Bkeys.</span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'></span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'>Si un
                                internaute ou une personne morale désire créer, à partir de son site, un lien hypertexte
                                vers le Site et/ou l’Application, et ce quel que soit le support, il doit
                                préalablement prendre contact avec Bkeys. Tout silence de Bkeys devra être
                                interprété comme un refus.</span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'></span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'>Bkeys
                                se réserve la possibilité de saisir toutes voies de droit à l’encontre des personnes
                                qui n’auraient pas respecté les interdictions contenues dans le présent
                                article.</span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'></span></p>

                <p style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify'><b><span style='font-family:"Arial"'>Article
                                8 – Dispositions diverses</span></b></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'>La
                                tolérance d’éventuels agissements contraires aux présentes CGU de la part de Bkeys,
                                ne vaut pas renonciation à se prévaloir desdites CGU.</span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'></span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'>Dans
                                l'hypothèse où l'une ou plusieurs des stipulations des présentes CGU serai(en)t
                                écartée(s) par une disposition législative ou réglementaire ou par une décision
                                de justice, toutes les autres dispositions demeureraient applicables.</span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'></span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><u><span style='font-family:"Arial"'>En
                                s'inscrivant sur le Site ou sur l’Application, l'Utilisateur reconnaît avoir
                                pris connaissance, compris et accepté sans réserve l'intégralité des présentes
                                CGU qui régissent avec force obligatoire l'ensemble des relations entre Bkeys</span></u><span
                                        style='font-family:"Arial"'>, les Vendeurs, les Ambassadeurs
                                et les Acquéreurs. Cette acceptation prend effet à compter de la date
                                d'inscription sur le Site ou sur l’Application de l'Utilisateur. Les présentes CGU
                                prévalent sur tout document contractuel ou non contractuel propre au Vendeur ou
                                propre à l'Acquéreur.</span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'></span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'>Bkeys
                                a la faculté de modifier les présentes CGU en fonction de l'évolution de son
                                offre et du marché. L'Utilisateur s'engage donc à consulter régulièrement les CGU
                                pour prendre connaissance des modifications y ayant été apportées.
                                L'utilisation du Site et/ou l’Application par les Utilisateurs constitue
                                l'acceptation par ces derniers des modifications apportées aux CGU. A défaut
                                d’acceptation de l’Utilisateur, ce dernier s’engage à ne plus utiliser le Site
                                et/ou l’Application et à supprimer son compte.</span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'></span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'>Les
                                présentes CGU ne créent aucune relation de sous-traitance, de coentreprise (joint-venture)
                                ou de relation de subordination entre Bkeys et l'Utilisateur quel qu’il soit.</span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'></span></p>

                <p style='text-align:justify;mso-layout-grid-align:none;
text-autospace:none'><span style='font-family:"Arial"'>Le
                                présent contrat est soumis à la loi Mauricienne. Tout litige qui pourrait
                                naître à l’occasion de l’application du présent contrat sera soumis à
                                l’arbitrage.</span></p>

                <p style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify'><b><span style='font-family:"Arial"'></span></b></p>

                <p style='text-align:justify'><b><span style='font-family:"Arial"'></span></b></p></div>)
}